import { getCurrentOrganization } from '../../state/reducers/organizations'
import { connect } from 'react-redux'
import MainMenu from '../../components/navigation/MainMenu'
import { getAccessJwtPayload } from '../../utils/auth'
import { RouteProps } from 'react-router'
import * as serviceActions from '../../state/actions/services'
import * as tripActions from '../../state/actions/trips'
import { getTripMenuServiceList } from '../../state/reducers/trip-menu-services'
import { IServiceListFilterDTO, IStoreState, ITripFilters, IZoneObject } from '../../types'
import { toggleZone, setVisible, getGoinzones } from '../../state/actions/goinzones'

const mapStateToProps = (state: IStoreState, ownProps: RouteProps) => {
  const org = getCurrentOrganization(state)
  const uid = state.user.currentUserId
  const loginData = getAccessJwtPayload()
  const userName = loginData ? loginData.firstName : ''
  const isAdmin = state.authorization.type === ''
  const resourcePermissions = state.teamMemberPermission.currentPermission
    ? state.teamMemberPermission.currentPermission.resourcePermissions
    : {}
  return {
    orgId: org ? org.id : '',
    orgName: org ? org.name : '',
    userName,
    isAdmin,
    resourcePermissions,
    orgRoles: loginData ? loginData.rolesInOrganizations : [],
    providerRoles: loginData ? loginData.rolesInProviders : [],
    services: getTripMenuServiceList(state.tripMenuService),
    tripFilters: state.trips.filters,
    zones: state.goinzones.items,
    visible: state.goinzones.visible,
    tripsPerService: state.trips.fetchTotalTripsPerService,
    location: ownProps.location,
    tempVehicleByService: state.trips.tempVehicleCountResponse ? state.trips.tempVehicleCountResponse.data : []
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchServices: (orgId: string) => dispatch(serviceActions.fetchTripMenuServiceList('active', orgId)),
    fetchTotalTripsPerService: (orgId: string, dto: IServiceListFilterDTO) =>
      dispatch(tripActions.getTotalTripsPerService(orgId, dto)),
    updateTripFilters: (filters: ITripFilters): Promise<any> => {
      return new Promise((resolve, reject) => {
        dispatch(tripActions.actionCreators.updateTripFilters(filters))
        resolve('')
      })
    },
    toggleZone: (zone: { [key: string]: IZoneObject } | {}) => {
      return dispatch(toggleZone(zone))
    },
    setVisible: (visible: boolean) => {
      return dispatch(setVisible(visible))
    },
    getGoinzones: (orgId: string, serviceId: string) => {
      return dispatch(getGoinzones(orgId, serviceId))
    },
    fetchService: (serviceId: string) => {
      dispatch(serviceActions.fetchService(serviceId))
    },
    getTempVehicleByServiceCount: () => {
      dispatch(tripActions.getTempVehicleByServiceCount())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainMenu)



// WEBPACK FOOTER //
// ./src/containers/navigation/MainMenu.ts